import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import '@/assets/css/tailwind.css';
import twemoji from "twemoji";

import VueRouter from 'vue-router'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history'
})

window.md = require("markdown-it")({
  html: true,
  xhtmlOut: true,
  breaks: false,
  linkify: true
});
var markdownItAttrs = require("markdown-it-attrs");
var emoji = require("markdown-it-emoji");

window.md.use(markdownItAttrs).use(emoji);

window.md.renderer.rules.emoji = function(token, idx) {
  return twemoji.parse(token[idx].content, { size: "svg", ext: ".svg" });
};


import VueTippy from "vue-tippy";
Vue.use(VueTippy);

import VTooltip from 'v-tooltip'

Vue.use(VTooltip)

import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

Vue.use(VuePlyr, {
  plyr: {}
})

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.5,
  throttleWait: 1400,
  attempt: 1
})
Vue.use(VueLazyload);

import VueMasonry from 'vue-masonry-css'
 
Vue.use(VueMasonry);

import VueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(VueSmoothScroll);

import VueScrollactive from 'vue-scrollactive';
Vue.use(VueScrollactive);

export const bus = new Vue();

import VueImageBrightness from 'vue-image-brightness'
 
Vue.use(VueImageBrightness)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
